<template>
  <div class="page">
    <klfs-header></klfs-header>

    <div class="page-wrapper">

      <div class="page-banner">
        <video
            ref="videoContainer"
            class="banner-video"
            src="../../assets/home.mp4"
            :autoplay="true"
            loop
            muted
            :show-play-btn="false"
            :show-center-play-btn="false"
            :controls="false"
            object-fit="cover"
            :style="{height:videoHeight + 'px'}"
        ></video>
      </div>

      <div class="section-block index-menu-bg">
        <div class="section-content">
          <div class="section-title-img flex-center">
            <img src="../../assets/index/title.png" alt="">
          </div>
          <div class="index-menus-wrap flex-center-between">
            <div class="index-menu" :class="menuCurrent == 0? 'current' : ''" data-index="0" @mouseenter="menuHover">
              <div class="menu-img">
                <img src="../../assets/index/menu-img1.png" alt="">
              </div>
              <div class="index-menu-content">
                <p>品牌介绍</p>
                <a class="menu-more" href="/brand.html#ppjs">了解更多</a>
              </div>
            </div>
            <div class="index-menu" :class="menuCurrent == 1? 'current' : ''" data-index="1" @mouseenter="menuHover">
              <div class="menu-img">
                <img src="../../assets/index/menu-img2.png" alt="">
              </div>
              <div class="index-menu-content">
                <p>品牌文化</p>
                <a class="menu-more" href="/brand.html#ppwh">了解更多</a>
              </div>
            </div>
            <div class="index-menu" :class="menuCurrent == 2? 'current' : ''" data-index="2" @mouseenter="menuHover">
              <div class="menu-img">
                <img src="../../assets/index/menu-img3.png" alt="">
              </div>
              <div class="index-menu-content">
                <p>发展历程</p>
                <a class="menu-more" href="/brand.html#pplc">了解更多</a>
              </div>
            </div>
            <div class="index-menu" :class="menuCurrent == 3? 'current' : ''" data-index="3" @mouseenter="menuHover">
              <div class="menu-img">
                <img src="../../assets/index/menu-img4.png" alt="">
              </div>
              <div class="index-menu-content">
                <p>全球版图</p>
                <a class="menu-more" @click="stepWorld">了解更多</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="brand-content">
        <h2 class="brand-title">品牌介绍</h2>
        <p class="brand-p">快乐番薯起源于2008年的福建厦门，是以番薯为主题的时尚休闲空间。快乐番薯主要布局2-5线下沉市场，目前拥有2000+门店，遍布全国28个省区、223个城市。快乐番薯以“让每位顾客都享受到物超所值的健康饮食”为使命、以“成为全球以番薯为主题的休闲饮食引领者”为愿景，坚持“客户至上、拥抱变化、利他共赢”的核心价值观，为企业员工、合作伙伴以及所有消费者带去“薯与你的快乐”。</p>
        <p class="brand-p">快乐番薯依靠灵活高效的总部管理，采用连锁经营模式拓展品牌营销渠道，同时也对加盟商进行业务和管理培训，对运营情况进行记录跟踪和监督管理。快乐番薯注重标准化建设，牵头制定福建省连锁协会团体标准 -《现制奶茶》和《现制奶茶操作规范》，鼎力促进奶茶行业的健康发展。</p>
        <p class="brand-p">快乐番薯重视加盟店运营支持工作，设立了招商中心、研发中心、运营中心、IT中心、品牌中心等五大支持中心，中心人才均选自行业精英，有着多年的从业经验，全程为加盟店服务。快乐番薯拥有自己研发的全套IT管理系统，可以为加盟店提供完善的技术支持，一部手机就能轻松管理门店。快乐番薯拥有专业的产品研发团队，核心成员都是在行业从业10年以上的高级技师，能够确保产品及时更新，让加盟店拥有持续的竞争力！快乐番薯拥有完整的"研发-采购-生产-仓储-物流-运营管理"供应链体系，成本控制是核心优势。秉承"高质平价"的产品理念，公司建立了专属的研发中心，并成立全资子公司天辅星食品有限公司，实现了核心原料自产化，从源头把控产品质量；自建仓储物流，为加盟商提供高效率，低成本运输配送服务。</p>
        <p class="brand-p">快乐番薯智能产业园在2026年投入使用，产业园位于福建省厦门海沧区，项目规划总建筑面积123221.194㎡，用地面积43659.683㎡，作为快乐番薯的茶饮全产业链研发和生产中心，可为上万家门店提供产品和物流服务。</p>
      </div>

      <div class="section-block index-bg-img">
        <img src="../../assets/index/index-img2.png" alt="">
      </div>

      <div class="section-block section-block-join">
        <div class="section-join-wrap">
          <div class="section-join-block flex">
            <div class="join-left">
              <div class="join-title">加盟咨询</div>
              <div class="join-menu-list flex-wrap flex-center-between">
                <a class="join-menu" href="/join.html#jmlc">
                  <span class="join-menu-num">01</span>
                  <span>加盟流程</span>
                </a>
                <a class="join-menu" href="/join.html#mdxx">
                  <span class="join-menu-num">02</span>
                  <span>门店形象</span>
                </a>
                <a class="join-menu" href="/join.html#jmzc">
                  <span class="join-menu-num">03</span>
                  <span>加盟支持</span>
                </a>
                <a class="join-menu" href="/join.html#jmyq">
                  <span class="join-menu-num">04</span>
                  <span>加盟要求</span>
                </a>
              </div>
            </div>
            <div class="join-right flex-1">
              <img class="image" src="../../assets/index/join.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div id="qqbt">
        <klfs-world></klfs-world>
      </div>

      <!-- 产品轮播展示 -->
      <div class="section-block product-section">
        <div class="product-section-wrap">

          <div class="product-list">
            <div class="product-list-item" :class="[pIndex == index? 'p-current' : '']" v-for="(item, index) in productList" :key="item.id">
              <div class="product-img">
                <img class="image" :src="item.url" alt="">
              </div>
            </div>
          </div>
          <div class="product-inner">
            <div class="product-inner-content">
              <div class="product-info-view">
                <div class="product-info-item" :class="[pIndex == index? 'p-current' : '']" v-for="(item, index) in productList" :key="item.id">
                  <h3 class="product-detail-title">{{ item.name }}</h3>
                  <p>{{ item.desc }}</p>
                  <p>{{ item.desc2 }}</p>
                  <a href="/product.html" class="product-info-btn">查看详情>></a>
                </div>
              </div>
              <div class="product-tabs-view">
                <div
                    class="product-tab"
                    :class="[pIndex == index? 'p-current' : '']"
                    v-for="(item, index) in productList"
                    :key="item.id"
                    @click="tapProduct(index)"
                >{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block section-brand-market">
        <div class="brand-market-section">
          <div class="section-block-title">品牌营销</div>
          <div class="brand-market-swiper-wrap">
            <div class="swiper-container swiper-brand" ref="swiperBrand">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item) in brandBanner" :key="item.id">
                  <img class="swiper-img" :src="item.imgUrl" />
                </div>
              </div>
            </div>
          </div>
          <div class="partner-view">
            <img src="../../assets/index/partner.png" alt="">
          </div>
        </div>
      </div>

      <div class="section-block section-brand-market">
        <div class="brand-market-section">
          <div class="section-block-title">品牌资讯</div>
          <a :href="'./article'+ newsList[0].id +'.html'" class="news-img" :title="newsList[0].title" v-if="newsList.length">
            <img class="image" :src="newsList[0].showImg" alt="">
          </a>
          <div class="news-list flex">
            <div class="news-item" v-for="(item, index) in newsList" :key="index">
              <div class="news-date">{{ item.showDate }}</div>
              <a :href="'./article'+ item.id +'.html'" :title="item.title" class="news-title">{{ item.title }}</a>
              <p class="news-text">{{ item.des }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <klfs-footer></klfs-footer>

    <klfs-sheng-ming></klfs-sheng-ming>
  </div>
</template>

<script>

import Swiper from 'swiper'
import KlfsHeader from "@/components/KlfsHeader.vue";
import KlfsFooter from "@/components/KlfsFooter.vue";
import KlfsWorld from "@/components/KlfsWorld.vue";
import KlfsShengMing from "@/components/KlfsShengMing.vue";
import host from "@/common/config.js"
export default {
  name: 'HomePage',
  components: {
    KlfsHeader,
    KlfsFooter,
    KlfsWorld,
    KlfsShengMing
  },
  data() {
    return {
      videoHeight: '800',
      menuCurrent: 0,
      productList: [
        {id: 0, name: '招牌薯圆奶茶', desc: '十八年坚守，一杯初心不改。', desc2: '无数人的青春回忆，经典永不过时。', url: require('@/assets/index/p-zpsync.jpg')},
        {id: 1, name: '超长杯冰鲜柠檬水', desc: '首创超长杯系列，超长超吸睛。', desc2: '严选好茶真料，打造茶饮界高质价比产品。', url: require('@/assets/index/p-ccbnms.jpg')},
        {id: 2, name: '烤番薯', desc: '烤番薯分为快乐番薯的烤番薯和别人家的烤番薯。', desc2: '冬季断货王，顾客反复回购的心头好。', url: require('@/assets/index/p-kfs.jpg')},
      ],
      pIndex: 0,
      pTimer: null,
      brandBanner: [
        {id: 3, imgUrl: require('@/assets/index/brand4.jpg')},
        {id: 0, imgUrl: require('@/assets/index/brand1.png')},
        {id: 1, imgUrl: require('@/assets/index/brand2.png')},
        {id: 2, imgUrl: require('@/assets/index/brand3.png')},
      ],
      brandSwiper: null,
      newPostData: {
        size: 3,
        page: 1,
        type: 12
      },
      newsList: [],
      source: ''
    }
  },
  created() {
    let urlPar = this.$util.parseURL(window.location.href)
    console.log(urlPar)
    if(urlPar.params && urlPar.params.c) {
     this.source = decodeURIComponent(urlPar.params.c)
      sessionStorage.setItem('klfs_source', this.source);
    } else if(urlPar.params && urlPar.params.sdclkid) {
      this.source = 'baidu'
      sessionStorage.setItem('klfs_source', this.source);
    }
    this.adjustVideoSize();
    window.addEventListener('resize', this.adjustVideoSize); // 监听窗口大小变化以调整视频大小

    this.getNews()
  },
  mounted() {
    this.loopProduct()
    this.$nextTick(() => {
      this.initBrandBanner()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustVideoSize); // 移除事件监听器以避免内存泄漏
  },
  methods: {
    stepWorld() {
      document.querySelector('#qqbt').scrollIntoView({
        behavior: 'smooth'
      });
    },
    getNews() {
      this.$util.fetchData(host.mainUrl + '/api/statistics/getTemplates', this.newPostData).then(res => {
        console.log(res)
        if(res.status == 200) {
          for(let item of res.payload.data) {
            item.showDate = this.$util.getDateHandle(item.created_date)
            item.showImg = this.$util.picUrlTrans(item.pic, host.imgUrl)
          }
          this.newsList = res.payload.data
        } else {
          console.log(JSON.stringify(res))
        }
      })
    },
    adjustVideoSize() {
      if(window.innerWidth >= 768) {
        this.videoHeight = window.innerHeight - 80
      } else {
        this.videoHeight = window.innerHeight - 68
      }
    },
    initBrandBanner() {
      // 预览图
      this.brandSwiper = new Swiper('.swiper-brand', {
        autoplay: {
          delay: 3000,//1秒切换一次
        },
        // speed: 300,
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        slideToClickedSlide: true, // 点击幻灯片时自动跳转
        // zoom: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          init: () => {
            console.log('init detailSwiper')
          },
        }
      });
    },
    // 风琴操作
    menuHover(e) {
      console.log(e)
      this.menuCurrent = e.currentTarget.dataset.index
    },
    tapProduct(index) {
      if(this.pTimer) {
        clearInterval(this.pTimer)
      }
      this.pIndex = index
      this.loopProduct()
    },
    // 定时处理商品轮播
    loopProduct() {
      this.pTimer = setInterval(() => {
        this.pIndex++
        if(this.pIndex >= 3) {
          this.pIndex = 0
        }
      }, 5000)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner-video {
  display: block;
  width: 100%;
  min-height: 500px;
  object-fit: cover;
  background-color: #000;
}
.index-menu-bg {
  background: linear-gradient(to bottom, #FF681E 1%, white 16%, white 50%);
  padding-top: 100px;
  padding-bottom: 170px;
  position: relative;
  margin-bottom: 26px;
}
.index-menu-bg:after {
  content: ' ';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("../../assets/index/index-bg-funso.png");
  background-repeat: no-repeat;
  background-position: bottom center;
  z-index: 0;
}
.index-menu-bg .section-content {
  position: relative;
  z-index: 1;
}
.section-content {
  max-width: 1420px;
  padding: 0 20px;
  margin: 0 auto;
}
.section-title-img img {
  display: block;
  width: 100%;
  margin-bottom: 120px;
}

.index-menus-wrap {
  margin: 0 -10px;
}
.index-menu {
  width: calc((45% - 20px) / 2);
  flex-shrink: 0;
  transition: all .5s ease;
  position: relative;
  border-radius: 25px;
  overflow: hidden;
  margin: 0 10px;
}
.index-menus-wrap .index-menu:nth-child(2),
.index-menus-wrap .index-menu:nth-child(4) {
  position: relative;
  top: 60px;
}
.index-menu.current {
  width: 28%;
}
.index-menu-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  color: #fff;
  text-align: center;
  padding-bottom: 60px;
  transition: all .5s;
  transform: translate(0px, 100px);
}
.index-menu:hover .index-menu-content {
  transform: translate(0, 0);
}
.index-menu.current .index-menu-content {
  transform: translate(0, 0);
}
.index-menu-content p {
  font-size: 40px;
}
.menu-more {
  display: block;
  width: 130px;
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  border: 1px solid #fff;
  border-radius: 36px;
  margin: 40px auto 0;
  cursor: pointer;
  transition: all 0.3s linear;
}
.menu-more:hover {
  background-color: #fff;
  color: var(--p);
}
.menu-img {
  position: relative;
  overflow: hidden;
}
.menu-img img {
  width: 100%;
  display: block;
  height: 732px;
  object-fit: cover;
}
.menu-img:after {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 63%;
  z-index: 1;
  background: linear-gradient(transparent 20%, var(--p) 90%);
  transition: 0.8s;
}

.index-bg-img img {
  display: block;
  width: 100%;
}

.section-block-join {
  margin-bottom: 30px;
  padding: 0 30px;
}
.section-join-wrap {
  max-width: 1540px;
  padding: 0 20px;
  margin: -60px auto 0;
  background-color: #fff;
  box-shadow: 2px 2px 6px rgba(141, 48, 2, 0.5);
  position: relative;
  z-index: 1;
  border-radius: 25px;
}
.section-join-block {
  padding: 60px;

}
.join-left {
  width: 46%;
  margin-right: 60px;
}
.join-title {
  font-size: 50px;
  font-weight: bold;
  color: var(--p);
  padding-bottom: 15px;
  border-bottom: 3px solid var(--p);
  margin-bottom: 60px;
  padding-top: 40px;
}
.join-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 262px;
  line-height: 52px;
  font-size: 35px;
  color: #fff;
  background-color: var(--p);
  padding: 2px;
  border-radius: 46px;
  margin-bottom: 40px;
}
.join-menu-num {
  border-radius: 50%;
  width: 46px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  font-size: 30px;
  background-color: #fff;
  color: var(--p);
  margin-right: 15px;
}


.product-section-wrap {
  position: relative;

}
.product-list {
  display: grid;
}
.product-list-item {
  position: relative;
  z-index: 0;
  grid-area: 1 / 1 / 2 / 2;
}
.product-list-item.p-current {
  z-index: 1;
}
.product-img {
  transform: scale(0.2);
  opacity: 0;
  transition: all 0.5s;
}
.product-list-item.p-current .product-img {
  transform: scale(1);
  opacity: 1;
}
.product-inner {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}
.product-inner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1420px;
  height: 100%;
  padding: 0 20px;
  margin: 0 auto;
}
.product-info-view {
  display: grid;
  width: 20%;
}
.product-info-item {
  grid-area: 1 / 1 / 2 / 2;
  opacity: 0;
  transition: all .5s;
}
.product-info-item.p-current {
  opacity: 1;
  z-index: 1;
}
.product-info-item p {
  font-size: 30px;
  color: var(--p);
}
.product-info-btn {
  display: inline-block;
  min-width: 190px;
  height: 56px;
  line-height: 56px;
  font-size: 30px;
  text-align: center;
  padding: 0 10px;
  color: #fff;
  background-color: var(--p);
  border-radius: 30px;
  margin-top: 60px;
  border: 2px solid var(--p);
  transition: all .5s;
}
.product-info-btn:hover {
  background-color: #fff;
  color: var(--p);
}
.product-tab {
  font-size: 30px;
  margin: 25px 0;
  text-align: right;
  position: relative;
  padding-right: 25px;
  cursor: pointer;
}
.product-tab:after {
  content: ' ';
  display: block;
  width: 14px;
  height: 14px;
  border: 2px solid #000;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -7px;
  border-radius: 50%;
  box-sizing: border-box;
}
.product-tab.p-current {
  color: var(--p);
}
.product-tab.p-current:after {
  border-color: var(--p);
}

.brand-market-section {
  max-width: 1420px;
  padding: 40px 20px;
  margin: 0 auto;
}
.section-block-title {
  font-size: 50px;
  font-weight: bold;
  color: var(--p);
  margin-bottom: 50px;
}

.swiper-brand {
  padding: 54px 0;
}
.swiper-img {
  display: block;
  width: 100%;
  margin: 0 auto;
  mix-blend-mode: multiply;
}
::v-deep .swiper-slide {
  transform: scale(1);
  transition: all .5s ease;
}
::v-deep .swiper-slide-active {
  transform: scale(1.4);
  z-index: 1;
}
::v-deep .swiper-slide-prev,
::v-deep .swiper-slide-next {
  opacity: 0.6;
}
.partner-view {
  text-align: center;
  margin-top: 80px;
}

.news-img {
  display: block;
  height: 450px;
  margin-bottom: 60px;
  overflow: hidden;
  border-radius: 20px;
}
.news-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.news-list {
  margin: 0 -30px;
}
.news-item {
  width: 33.33%;
  border-right: 1px solid #999;
  padding-right: 30px;
  padding: 10px 30px;
}
.news-list .news-item:nth-child(3n+3) {
  border-right: 0;
}
.news-title {
  line-height: 1.2;
  font-size: 24px;
  font-weight: normal;
  margin: 5px 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.news-item .news-title:hover {
  color: var(--p);
}
.news-date,
.news-text {
  font-size: 14px;
  color: var(--g);
}
.news-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-detail-title {
  display: none;
  color: var(--p);
  font-size: 20px;
  margin-bottom: 12px;
}

#qqbt {
  padding-top: 80px;
}

.brand-content {
  max-width: 1120px;
  padding: 0 20px;
  margin: 0 auto 80px;
}
.brand-title {
  font-family: 'bold';
  text-align: center;
  font-size: 38px;
  color: var(--p);
  margin-bottom: 30px;
}
.brand-p {
  font-size: 16px;
  color: #666;
  text-indent: 2em;
  line-height: 1.68;
  margin-bottom: 16px;
}

@media screen and (max-width: 1400px) {
  .index-menu-bg:after {
    background-size: 100%;
  }
  .join-menu {
    width: 200px;
    font-size: 24px;
  }
  .join-menu-num {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 28px;
  }
  .product-info-item p {
    font-size: 20px;
  }
  .product-tab {
    font-size: 20px;
  }
  .partner-view img {
    display: block;
    width: 100%;
  }
}
@media screen and (max-width: 1100px) {
  .join-menu {
    width: 160px;
    font-size: 18px;
  }
}

@media screen and (max-width: 768px) {
  .index-menu-bg {
    background: linear-gradient(to bottom, #FF681E 0.5%, white 6%, white 60%);
    padding-top: 40px;
    padding-bottom: 60px;
  }
  .section-title-img img {
    margin-bottom: 20px;
  }
  .index-menus-wrap {
    flex-wrap: wrap;
    margin: 0 -8px;
  }
  .index-menu {
    width: 50%;
    margin: 0 0 16px 0;
    padding: 0 8px;
  }
  .index-menu.current {
    width: 50%;
  }
  .menu-img img {
    height: 280px;
  }
  .index-menus-wrap .index-menu:nth-child(2), .index-menus-wrap .index-menu:nth-child(4) {
    top: unset;
  }
  .index-menu.current .index-menu-content,
  .index-menu-content {
    transform: translate(0px, 0);
  }
  .index-menu-content p {
    font-size: 20px;
  }
  .index-menu-content {
    padding-bottom: 20px;
  }
  .menu-more {
    font-size: 14px;
    width: 100px;
    margin-top: 10px;
  }
  .index-menu-bg:after {
    margin: 0 20px;
    background-size: 100%;
  }
  .section-block-join {
    padding: 0 20px;
    margin-bottom: 0;
  }
  .section-join-block {
    flex-direction: column;
    padding: 20px 0;
  }
  .join-left {
    margin: 0;
    width: 100%;
  }
  .join-title {
    font-size: 24px;
    text-align: center;
    margin: 10px 1% 20px;
    padding-top: 0;
  }
  .join-menu {
    width: 46%;
    line-height: 38px;
    font-size: 14px;
    margin: 10px 1%;
  }
  .join-menu-list {
    margin-bottom: 30px;
  }
  .join-menu-num {
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    margin-right: 4px;
  }

  .product-section-wrap {
    padding-top: 40px;
  }
  .product-inner {
    position: unset;
  }
  .product-tabs-view {
    display: none;
  }
  .product-info-view {
    width: 100%;
    text-align: center;
    padding-top: 20px;
  }
  .product-info-item p {
    font-size: 14px;
  }
  .product-info-btn {
    min-width: 110px;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    margin-top: 30px;
  }
  .product-detail-title {
    display: block;
  }
  .section-block-title {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
  }

  ::v-deep .swiper-slide {
    transform: scale(1.6);
  }
  ::v-deep .swiper-slide-active {
    transform: scale(2.4);
    z-index: 1;
  }
  ::v-deep .swiper-slide-prev,
  ::v-deep .swiper-slide-next {
    opacity: 0.8;
  }
  .partner-view {
    margin-top: 20px;
  }
  .partner-view img {
    display: block;
    width: 100%;
  }

  .news-img {
    height: 200px;
    margin-bottom: 20px;
  }
  .news-list {
    flex-direction: column;
  }
  .news-item {
    width: 100%;
  }
  .news-title {
    font-size: 18px;
    font-weight: bold;
  }
  .news-date {
    font-size: 12px;
  }

  .brand-market-section {
    padding: 40px 15px;
    overflow: hidden;
  }
  .section-content {
    padding: 0 15px;
  }
  .section-join-wrap {
    margin-top: -10px;
  }
  #qqbt {
    padding-top: 60px;
  }
  .brand-content {
    margin-bottom: 40px;
  }
  .brand-title {
    font-size: 28px;
    margin-bottom: 16px;
  }
  .brand-p {
    font-size: 14px;
  }
}
</style>
